// ══════════════════════════════════════════════════════════════════════════════════════════════
//  t667 · LA ESPERA AL ENTRAR EN LA CLÍNICA, CON SALIDA (3-nov-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  Antes vivía dentro de PrivateRoute (App.jsx): el logo de Biango se queda mientras llega la marca de la clínica en la que se
//  entra (hooks/useBranding · `cargando`) y las citas de hoy (components/CargandoMarca · useAdelantarLoDeHoy, con su techo de
//  6 s). La de las citas tenía techo; LA DE LA MARCA NO. El dueño, 3-nov: «al entrar a la clínica se queda en Biango y no
//  carga». Con una respuesta de la marca que no llegaba (ver hooks/useBranding), la pantalla de carga no se iba nunca.
//
//  Ahora:
//   · useBranding apaga su espera pase lo que pase (fallo, página de error, red cortada) y tiene plazo;
//   · y aquí, por si aun así no llega, un TECHO: pasado TECHO_ENTRADA_MS con la marca sin llegar, se dice qué pasa y se ofrece
//     «Volver a intentar» (vuelve a preguntar sin recargar) y «Recargar la página». Nunca una pantalla de carga sin salida.
//  La mide backend/routes/entrar-en-cada-tipo-carga.test.js montando esto con el useBranding de verdad, una clínica de cada
//  tipo de negocio.
import { useEffect, useState } from 'react'
import CargandoMarca, { useAdelantarLoDeHoy } from './CargandoMarca'
import { useBranding, olvidarBranding } from '../hooks/useBranding'
import { PantallaErrorDeCarga } from './ErrorAlCargar'
import { t } from '../utils/i18n'

export const TECHO_ENTRADA_MS = 20000

export default function PuertaDeEntrada({ children }) {
  const marca = useBranding()
  // LAS CITAS DE HOY: el logo se queda hasta que contestan (o 6 s), para entrar con la agenda ya pintada (ver CargandoMarca).
  const datosListos = useAdelantarLoDeHoy()
  const esperandoMarca = !!(marca && marca.cargando)
  const [pasado, setPasado] = useState(false)
  const [intento, setIntento] = useState(0)
  useEffect(() => {
    if (!esperandoMarca) { setPasado(false); return undefined }
    const reloj = setTimeout(() => setPasado(true), TECHO_ENTRADA_MS)
    return () => clearTimeout(reloj)
  }, [esperandoMarca, intento])
  if (esperandoMarca && pasado) {
    return (
      <PantallaErrorDeCarga
        titulo={t('components.PuertaDeEntrada.titulo', 'La clínica está tardando en abrir')}
        detalle={t('components.PuertaDeEntrada.detalle', 'Biango no ha recibido todavía los datos de esta clínica. Puede ser la conexión o que el servidor se esté actualizando. Vuelve a intentarlo en unos segundos.')}
        onReintentar={() => { setPasado(false); setIntento((n) => n + 1); olvidarBranding() }}
      />
    )
  }
  if (esperandoMarca || !datosListos) return <CargandoMarca />
  return children
}
